export const triggerFileDownloadDialog = (data: any, type: string, fileName: string) => {
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.download = fileName;
    anchor.href = url;
    anchor.target = '_self';
    anchor.click();
};
